import React, { PureComponent } from 'react';
import { Row, Col } from 'antd';
import { LinkType } from '../../../tools';
import { LinkTypeMode } from '../../../../types';

//图片广告位项
export class JumpLink extends PureComponent<{
    onChange?: (value: any) => void;
    value?: any;
    linkTypes?: Array<any>;
    linkTypeMode?: LinkTypeMode;
    selector?: any;
}> {
    state = {
        uploadLoading: false,
    };
    change = (val: any) => {
        const { onChange } = this.props;
        onChange(val);
    };

    render() {
        const {
            value = {
                linkType: 'none',
                linkParams: '',
            },
            linkTypes,
            linkTypeMode,
            selector,
        } = this.props;
        console.log(value, 'value');
        return (
            <Row className="entry-item">
                <Col className="entry-item-content" span={19}>
                    <LinkType
                        selector={selector}
                        linkTypes={linkTypes}
                        linkTypeMode={linkTypeMode}
                        value={value}
                        onChange={this.change}
                    />
                </Col>
            </Row>
        );
    }
}
